<template>
    <c-dialog ref="dialog" mode="slide" width="70vw" mask-close
              @close="dialogFormEditConfirm($refs.handoverForm, arguments)" @resolve="submitHandle">
        <c-form ref="handoverForm" column="3" vertical unit-width="100%">
            <c-form link-parent>
                <c-form-item label="备注">
                    <c-input type="textarea" name="remark" v-model="remark" maxlength="200"></c-input>
                </c-form-item>
            </c-form>
            <c-title>退库商品明细</c-title>
            <c-form-item :label="false" name="product_list" colspan="3">
                <m-operate border>
                    <c-input ref="codeInput" name="purchase_code" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanCodeHandle">
                        <template #appendIcon><i class="tf-scan"></i></template>
                    </c-input>
                    <c-button color="main" @click="scanCodeHandle">确定</c-button>
                    <c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
                </m-operate>
                <c-table ref="productTable" :data="scannedList" border :paging="false">
                    <template #empty>
                        <c-empty message="请扫描产品背贴码"></c-empty>
                    </template>

                    <c-table-column type="selector" width="40"></c-table-column>
                    <c-table-column label="产品信息" width="300">
                        <template #default="{data}">
                            <div class="product-info">
                                <c-state v-if="data.level_type" tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                                <span v-else-if="data.level_name" class="level-tag">{{data.level_name}}</span>
                                <span class="product-text">{{getProductText(data)}}</span>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column label="背贴码" width="150">
                        <template #default="{data}">{{data.produce_unique_code}}</template>
                    </c-table-column>
                    <c-table-column label="IMEI" width="160">
                        <template #default="{data}">{{data.produce_imei || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="成本价" width="90">
                        <template #default="{data}"><span class="price-text">{{data.cost_price ? '¥' + data.cost_price : '-'}}</span></template>
                    </c-table-column>
                    <c-table-column label="状态" width="90">
                        <template #default="{data}">
                            <c-state v-if="data.state" tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                            <span v-else class="status-tag">已入库</span>
                        </template>
                    </c-table-column>
                    <c-table-column label="入库时间" width="150">
                        <template #default="{data}">{{data.first_stock_in_time || '-'}}</template>
                    </c-table-column>
                    <c-table-column label="操作" width="80" type="button">
                        <template #default="{data}">
                            <c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>
                <!-- 已扫码列表 -->
            </c-form-item>
        </c-form>
        <!--创建/编辑部门弹窗-->
        <department-edit ref="departmentEdit"></department-edit>
        <!--创建/编辑用户弹窗-->
        <sysuser-edit ref="sysuserEdit"></sysuser-edit>
    </c-dialog>
</template>

<script>
import scanCodeGuard from '@/mixins/scan_code_guard';

export default {
    name: 'codePurchaseOut',
    mixins: [scanCodeGuard],

    data() {
        return {
            operatorType:1,         //1=申请退库  2=确认退库
            remark:'',
            scanCode: '',          //背贴码
            scannedList: []       //已加载的唯一码列表
        }
    },

    methods: {
        /*********聚焦输入框**********/
        focusInput() {
            this.$nextTick(() => {
                var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
                if (input) input.focus();
            });
        },

        /*********【背贴码】扫码处理**********/
        scanCodeHandle() {
            var code = this.scanCode.trim();
            if (!code) {
                this.$message({message: '请输入背贴码', type: 'warn'});
                return;
            }
            if (this.scannedList.some(item => item.produce_unique_code == code)) {
                this.$message({message: '该背贴码已扫描', type: 'warn'});
                this.scanCode = '';
                this.focusInput();
                return;
            }
            //防止连续点击【确定】对同一背贴码并发请求，导致已扫列表重复录入
            if (this.isScanCodePending(code)) {
                this.$message({message: '该背贴码正在校验，请勿重复提交', type: 'warn'});
                return;
            }
            this.lockScanCode(code);
            this.request({
                url: '/productCode/access/detail',
                data: {
                    produce_unique_code: code
                },
                success: (data) => {
                    if (this.operatorType == 1){
                        if(data.state == 10){
                            this.pushScannedItem(data, code);
                        }else {
                            this.$message({message: '背贴码【'+code+'】不在库，无法进行“申请退库”操作', type: 'warn'});
                        }
                    }else if (this.operatorType == 2){
                        if(data.state == 35){
                            this.pushScannedItem(data, code);
                        }else {
                            this.$message({message: '背贴码【'+code+'】尚未申请退库，无法进行倩倩“确认退库”操作', type: 'warn'});
                        }
                    }else if (this.operatorType == 3){
                        if(data.state == 35){
                            this.pushScannedItem(data, code);
                        }else {
                            this.$message({message: '背贴码【'+code+'】尚未申请退库，无法进行倩倩“取消退库”操作', type: 'warn'});
                        }
                    }
                    this.scanCode = '';
                    this.focusInput();
                },
                fail: (msg) => {
                    this.$message({message: '背贴码不存在或已被删除，请检查', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                },
                complete: () => {
                    this.unlockScanCode(code);
                }
            });
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*********移除已扫项**********/
        removeItem(data) {
            this.scannedList = this.scannedList.filter(item => item.id != data.id);
            this.focusInput();
        },

        /*********批量移除选中项**********/
        batchRemove() {
            let selectedList = this.$refs.productTable.getData('selected');
            if (!selectedList || selectedList.length == 0) {
                this.$message({message: '请先勾选要移除的记录', type: 'warn'});
                return;
            }
            var ids = selectedList.map(item => item.id);
            this.scannedList = this.scannedList.filter(item => !ids.includes(item.id));
            this.focusInput();
        },
        /**
         *
         * @param operatorType
         * @param list
         */
        open(operatorType,list) {
            this.operatorType = operatorType;
            var title = "";
            if (this.operatorType==1){
                title = "申请退库";
            }else if (this.operatorType==2) {
                title = "确认退库";
            }else if (this.operatorType==3){
                title = "取消退库";
            }
            this.scannedList = [];
            //清空表单数据
            this.$refs.handoverForm.clear();
            this.$refs.dialog.open({
                title: title
            });

            if (list && list.length > 0){
                list.forEach(item => {
                    this.scanCode = item.produce_unique_code
                    this.scanCodeHandle();
                });
            }
            
            //自动定位到【背贴码输入框】
            this.focusInput();
        },

        /*******提交编辑数据********************/
        submitHandle(stop, next) {
            stop();
            var product_list = this.$refs.productTable.getData();
            if (!product_list || product_list.length == 0){
                this.$message({
                    message: '请至少输入一个商品',
                    type: 'warn'
                });
                return false;
            }
            //产品列表
            let produce_unique_id_list = product_list.map(item => {
                return item.id;
            });
            var url = '';
            if (this.operatorType==1){
                url = '/product/unique_code/outstorage/apply';
            }else if (this.operatorType==2){
                url = '/product/unique_code/outstorage/confirm';
            }else if (this.operatorType==3){
                url = '/product/unique_code/outstorage/cancel';
            }
            this.request({
                url:url,
                data: {
                    produce_unique_id_list: produce_unique_id_list,
                    remark: this.remark
                },
                loading: true,
                success: (res, msg) => {
                    next();
                    var message = "";
                    if (this.operatorType==1){
                        message = "申请退库";
                    }else if (this.operatorType==2) {
                        message = "确认退库";
                    }else if (this.operatorType==3){
                        message = "取消退库";
                    }
                    this.$message({
                        type: 'success',
                        message: message+'成功'
                    });
                    //刷新页面
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.section-title {
    display flex
    align-items center
    margin 12px 0 8px
    .title-icon {
        width 4px
        height 16px
        background #1890ff
        border-radius 2px
        margin-right 8px
    }
    .c-title {
        margin 0
    }
}
.scan-toolbar {
    padding 3px 3px
    background #fafafa
    border 1px solid #e8e8e8
    border-bottom 0
    border-radius 4px 4px 0 0
    > * + * {
        margin-left 10px
    }
    .scan-input-box {
        position relative
        width 260px
        /deep/ .c-input input {
            background #fffbe6
            padding-right 32px
        }
        .scan-icon {
            position absolute
            right 10px
            top 50%
            transform translateY(-50%)
            color #999
            cursor pointer
        }
    }
}
.empty-state {
    padding 60px 0
    text-align center
    color #999
    .empty-icon {
        color #ccc
    }
    p {
        margin-top 10px
        font-size 14px
    }
}
.product-info {
    display flex
    align-items center
    gap 8px
    .level-tag {
        display inline-block
        padding 2px 5px
        border-radius 4px
        background #f5f5f5
        color #333
        font-size 12px
        line-height normal
        white-space nowrap
    }
    .product-text {
        flex 1
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
    }
}
.price-text {
    color #333
    text-decoration underline
}
.status-tag {
    display inline-block
    padding 2px 5px
    border-radius 4px
    background #e6f7e6
    color #2ebc78
    font-size 12px
    line-height normal
    white-space nowrap
}
</style>